import { Action, ThunkAction } from '@reduxjs/toolkit';

import { Insertion } from '@paragon/contract-library';
import { EnvironmentState } from '@paragon/environment-tools';
import { LogInDataState } from '@paragon/login-tools';
import { MaterialListsState } from '@paragon/material-lists';
import { SpinnerMessagesState } from '@paragon/task-spinner';

import { ChangeTrackerState } from './changeTracker';
import { InsertionsState } from './insertionsSlice';
import { LayoutModelsState, projectArchived, projectSynchronized } from './layoutModelsSlice';

export const LAYOUT_MODEL_SYNCHRONIZED_ACTIONS = [projectSynchronized.type, projectArchived.type];

export interface ComponentDesignBulkMovement {
  targetContainerGuid: string;
  pathsToTargetContainer: string[];

  insertionsByProject: {
    [projectGuid: string]: Insertion[];
  };
}

export function getMovedComponentInsertions(movement: ComponentDesignBulkMovement) {
  return Object.values(movement.insertionsByProject).flat();
}

export interface LayoutModelsLibraryState {
  readonly changeTracker: ChangeTrackerState;
  readonly insertions: InsertionsState;

  /**
   * Note that changes to layout models aren't applied here until the changes are saved.  Use the
   *   `getLayoutModelsWithPendingChanges` selector instead of directly accessing this property.
   */
  readonly layoutModels: LayoutModelsState;
}

export interface LayoutModelsLibraryClientState extends LayoutModelsLibraryState {
  readonly environment: EnvironmentState;
  readonly logInData: LogInDataState;
  readonly materialLists: MaterialListsState;
  readonly spinnerMessages: SpinnerMessagesState;
}

export type LayoutModelsLibraryThunkAction<T> = ThunkAction<T, LayoutModelsLibraryClientState, void, Action>;
export type AsyncLayoutModelsLibraryThunkAction<T> = ThunkAction<
  Promise<T>,
  LayoutModelsLibraryClientState,
  void,
  Action
>;
